import { SignupMode } from 'signup-constants/SignupMode';
import { SignupEmbedder } from 'signup-embedder';
export const getSignupMode = () => {
  const isInstanceOfSignupEmbedder = SignupEmbedder.isActive();
  const isPopup = SignupEmbedder.isPopup();

  // eslint-disable-next-line no-nested-ternary
  return isInstanceOfSignupEmbedder ? isPopup ? SignupMode.Popup : SignupMode.Embedded : SignupMode.Standalone;
};